<template>
  <div :class="`tw-h-[100%] tw-flex tw-bg-white tw-flex-col ${mainClass}`">
    <div
      :class="`tw-px-[14px] tw-py-[10px] tw-items-center tw-justify-between tw-flex ${headerClass}`"
    >
      <CybersystemLogo />
      <Button1
        :id="`vendro-basic-header-btn`"
        :class="`!tw-w-[160px] !tw-h-[36px] tw-rounded-[100px] tw-bg-[#387DFF] tw-text-white tw-text-[13px] tw-font-[poppins] tw-text-center tw-font-[500]`"
        :title="
          getComponentUiText('app-vendor-base-page-join-cybersystem-button-1')
        "
        :disabled="false"
        @click="onNavigateToLandingPage"
      />
    </div>
    <div :class="`tw-w-[100%] ${bodyClass} vendor-container`">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import router from "@/router";
import { getComponentUiText } from "@/utils/utilities";
import Button1 from "@/components/common/button1.vue";
import CybersystemLogo from "@/components/svgs/cybersystemLogo.vue";
const prop = defineProps({
  mainClass: {
    type: String,
    required: false,
    default: "",
  },
  headerClass: {
    type: String,
    required: false,
    default: "",
  },
  bodyClass: {
    type: String,
    required: false,
    default: "",
  },
});
const onNavigateToLandingPage = () => {
  const query = { openModal: "true" };
  router.push({ path: "/", query });
};
</script>

<style lang="scss" scoped>
.vendor-container {
  background-color: #0345bd;
}
@media screen and (min-width: 640px) {
  .vendor-container {
    padding: 50px;
  }
}
@media screen and (min-width: 1025px) {
  .vendor-container {
    padding: 100px;
  }
}
</style>
